import { Colors } from '@sweatpals/react-ui-kit';

export const eventAuthorsStyles = () => ({
	authorAvatar: {
		borderRadius: '50%',
		position: 'absolute',
		border: '1px solid #171717',
	},
	authorNameText: {
		flex: 1,
		color: '#FFFFFF',
		fontFamily: 'General Sans',
		fontSize: '15px',
		fontWeight: 600,
		lineHeight: '20px',

		'& a': {
			color: '#FFFFFF',
			textDecoration: 'unset',
			cursor: 'pointer',
			outline: 'unset',

			'&:hover': {
				textDecoration: 'underline',
				textDecorationColor: Colors['FF6000'],
				textDecorationThickness: '2px',
				textUnderlineOffset: '4px',
			},
		}
	},
});
